import React from "react";
import arrowLeftIcon from "../assets/images/arrow-left.svg";

const BackButton = () => {
  const handleBackClick = () => {
    window.history.back();
  };

  return <img src={arrowLeftIcon} onClick={handleBackClick} />;
};

export default BackButton;
